export default "__VITE_ASSET__Ca3mU$G2__"